import {
  Image,
  ImageWrapper,
  LinkWrapper,
  ReadTimeText,
  TextWrapper,
  TitleText,
  Wrapper,
} from './article.style';
import { ImageProps } from 'next/image';

// --------------------------------------------------------------------------

export interface ArticleProps {
  className?: string;
  image?: ImageProps;
  title: string;
  readTime?: string;
  url: string;
  onClickArticle?: () => void;
}

// --------------------------------------------------------------------------

const Article = ({
  className,
  image,
  title = 'wow',
  readTime,
  url,
  onClickArticle,
}: ArticleProps) => {
  if (!title || !url) {
    return null;
  }

  return (
    <Wrapper className={className}>
      <LinkWrapper
        href={url}
        target="_blank"
        aria-label={`Read this article: ${title}`}
        onClick={onClickArticle}
      >
        <ImageWrapper>
          {image && <Image fill quality={100} sizes={`130px`} {...image} />}
        </ImageWrapper>
        <TextWrapper>
          <TitleText aria-label={title} as="h4">
            {title}
          </TitleText>
          {!!readTime && (
            <ReadTimeText as={'p'}>
              Estimated reading time: {readTime}
            </ReadTimeText>
          )}
        </TextWrapper>
      </LinkWrapper>
    </Wrapper>
  );
};

// --------------------------------------------------------------------------

export default Article;
